import { Box, Typography } from "@mui/material";
import React from "react";
import TemplateTable from "../components/Fabrication/TemplateTable";
import CreateTemplateForm from "../components/Fabrication/CreateTemplateForm";
import TemplateList from "../components/Fabrication/TemplateList";
import useTemplate from "../hooks/useTemplate";
import DeleteConfirmationPopup from "../components/DeleteConfirmationPopup";
import { actionType } from "../utils/constant";
import AppButton from "../components/AppButton";
import { useNavigate } from "react-router-dom";

const styles = {
  nonPermissionContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "75vh",
    flexDirection: "column",
  },
};

const Fabrication = () => {
  const navigate = useNavigate();
  const {
    selectedModal,
    createModalDialogue,
    allTemplates,
    carausalCollapsed,
    handleSubmit,
    onTemplateDelete,
    createTemplateClick,
    onTemplateClick,
    setCarausalCollapsed,
    setSearchTerm,
    pagination,
    handlePageChange,
    deleteModal,
    setDeleteModal,
    setDeleteSelectedModel,
    deleteSelectedModel,
    loading,
    fetchTemplatesAPI,
    handleClose,
    permissions,
  } = useTemplate();

  return (
    <>
      {permissions.actions.includes(actionType.template_view) ? (
        <Box>
          <TemplateList
            onTemplateClick={onTemplateClick}
            createTemplateClick={createTemplateClick}
            allTemplates={allTemplates}
            collapsed={carausalCollapsed}
            setCollapsed={setCarausalCollapsed}
            // onTemplateEdit={onTemplateEdit}
            onTemplateDelete={(template) => {
              setDeleteModal(true);
              setDeleteSelectedModel(template);
            }}
            setSearchTerm={setSearchTerm}
            pagination={pagination}
            handlePageChange={handlePageChange}
            loading={loading}
          />

          {selectedModal && (
            <TemplateTable
              model={selectedModal}
              fetchTemplatesAPI={fetchTemplatesAPI}
              headerCollapsed={carausalCollapsed}
            />
          )}

          <CreateTemplateForm
            open={createModalDialogue}
            onClose={handleClose}
            onSave={handleSubmit}
            initialData={null}
            isEditing={false}
            isTemplateCreation={true}
            title="Create Template"
          />

          <DeleteConfirmationPopup
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            onConfirm={onTemplateDelete}
            itemName={deleteSelectedModel?.model_name}
          />
        </Box>
      ) : (
        <Box sx={styles.nonPermissionContainer}>
          <Typography variant="h5" mb={3}>
            You don't have permission to view templates.
          </Typography>
          <AppButton
            label="Back to Dashboard"
            onClick={() => navigate("/dashboard")}
          />
        </Box>
      )}
    </>
  );
};

export default Fabrication;
